module.exports = __webpack_public_path__ + "static/media/docker.46dcb463.svg";